import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSomaliland = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1442)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2536 16.1739C23.736 14.8739 24 13.4678 24 12C24 10.5322 23.736 9.12609 23.2536 7.82611L12 6.78262L0.746391 7.82611C0.264047 9.12609 0 10.5322 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 17.2174L23.2536 16.1739Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C17.1595 24 21.5581 20.7435 23.2536 16.1739H0.746338C2.4419 20.7435 6.84037 24 12 24Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C6.84037 0 2.4419 3.2565 0.746338 7.82611H23.2536C21.5581 3.2565 17.1595 0 12 0Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 9.39133L12.6475 11.3841H14.7429L13.0477 12.6159L13.6953 14.6087L12 13.3772L10.3047 14.6087L10.9523 12.6159L9.25706 11.3841H11.3525L12 9.39133Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5652 2.34784V4.78257C15.5652 5.16624 15.2532 5.47824 14.8696 5.47824V6.52173C15.8286 6.52173 16.6087 5.74159 16.6087 4.78257V2.34784H15.5652Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.08697 4.78257C8.08697 5.16624 7.77492 5.47824 7.3913 5.47824V6.52173C8.35031 6.52173 9.13045 5.74159 9.13045 4.78257V2.34784H8.08697V4.78257Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9998 2.34784H15.0433V4.78257H13.9998V2.34784Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.4348 3.73909C12.4348 3.83499 12.3567 3.91304 12.2609 3.91304C12.165 3.91304 12.0869 3.83499 12.0869 3.73909V2.34784H11.0434V3.73909C11.0434 3.83499 10.9654 3.91304 10.8695 3.91304C10.7736 3.91304 10.6956 3.83499 10.6956 3.73909V2.34784H9.65213V3.73909C9.65213 4.41043 10.1982 4.95652 10.8695 4.95652C11.128 4.95652 11.3678 4.87529 11.5651 4.73734C11.7625 4.87529 12.0023 4.95652 12.2608 4.95652C12.3129 4.95652 12.3641 4.95287 12.4144 4.94645C12.3405 5.25109 12.0661 5.47824 11.7391 5.47824V6.52173C12.6981 6.52173 13.4782 5.74159 13.4782 4.78257V3.73909V2.34784H12.4347L12.4348 3.73909Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.65218 5.4783H11.2174V6.52179H9.65218V5.4783Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1442",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSomaliland;
